var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgResetToRecommendation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 19,
    viewBox: "0 0 20 19",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 3h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 1v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 15v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 16.5h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 10-3.7999-1.5c-.8-.3-1.4001-.9002-1.7001-1.7002l-1.5-3.7998-1.5 3.7998c-.3.8-.89995 1.4002-1.69995 1.7002l-3.80005 1.5 3.80005 1.5c.8.3 1.39995.9002 1.69995 1.7002l1.5 3.7998 1.5-3.7998c.3-.8.9001-1.4002 1.7001-1.7002z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgResetToRecommendation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reset-to-recommendation.cc32631d42d0b2ef5402dc004ee2c255.svg";